module.exports = __webpack_public_path__ + "img/img1.c5588e8b.jpg";